import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatButtonModule } from '@angular/material/button'
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog'
import { MatListModule } from '@angular/material/list'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatCardModule } from '@angular/material/card'
import {NgForOf, NgIf, NgOptimizedImage, NgStyle} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {
  PendingPatientsAlertService
} from '../../../../core/services/pending-patients-alert/location/pending-patients-alert.service';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
@Component({
  selector: 'information-card',
  standalone: true,
  imports: [
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatIcon,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ],
  templateUrl: './information-card.component.html',
  styleUrls: ['./information-card.component.scss'],
})
export class InformationCardComponent implements OnInit{
  constructor(
    private formBuilder: FormBuilder,
    private service: PendingPatientsAlertService,
  private dialogRef: MatDialogRef<InformationCardComponent>,
  @Inject(MAT_DIALOG_DATA) public data: number,

  ) {
  }
  @Output() response = new EventEmitter()
  @Input() alert!: {respondido_por_id: number | null, observacoes: string | null, respondido_por_nome: string | null, respondido_em: string | null, classificacao_id: number, alerta_id: number, medicao_id: number, valor_medido: number, nivel_acionado: number, criado_em: string, classificacao: string, paciente_id: number, paciente_nome: string, telefone_whatsapp: string, minutos_passados: number, status_tempo: string};
  form!: FormGroup
  loading: boolean = false
  ngOnInit() {
    this.createForm()
  }
  createForm(){
    this.form = this.formBuilder.group({
      obs: [''],
    })
  }
  close() {
    this.dialogRef.close()
  }
  salvar(){
    this.loading = true
    this.service.answerAlert(this.data,{observacoes: this.form.get('obs')!.value}).subscribe({
      next: data => {
        this.response.emit(true)

      }, error: error => {
        this.response.emit('false')
        this.loading = false
      },
      complete: () => {
        this.close()
        this.loading = false

      }
      }
    )
  }

  }
